import axios from "axios";
import { handleError } from "@low6dev/react-utils";
import { toast } from "react-toastify";
import { setBetbarParent } from "components/feature/betbar/actions";
import { logXtremePush } from "utils";

export const SET_AUTH = "auth:SET_AUTH";

export const setAuth = (auth) => (dispatch) => {
  dispatch({
    type: SET_AUTH,
    payload: auth,
  });
};

export const placeBet = ({
  translations,
  selections,
  handlePlaceBetSuccess,
}) => async (dispatch, getState) => {
  dispatch(
    setBetbarParent({
      isPlacingBet: true,
    })
  );

  let res;

  const { activePickem } = getState().betbarParent;
  const { isOver24 } = getState().auth;

  try {
    res = await axios.post(`/pickems/${activePickem?.id}/bets`, {
      selections,
    });
  } catch ({ response }) {
    if (response?.data?.code === "mobileNumberIsNotVerified") {
      toast.error(translations.makePicksErrorPhone);
    } else if (response?.data?.code === "userIsCoolingOff") {
      toast.error(translations.makePicksErrorCooling);
    } else if (response?.data?.code === "identityReferred") {
      toast.error(translations.makePicksErrorBalance);
    } else if (response?.data?.code === "insufficientFunds") {
      toast.error(translations.makePicksErrorBalance);
    } else if (response?.data?.code === "pickemBetPerUserExceeded") {
      // do nothing (existing picks will be loaded)
    } else if (response?.data?.code) {
      toast.error(`Error: ${response?.data?.code}`);
    }

    dispatch(
      setBetbarParent({
        isPlacingBet: false,
      })
    );

    handleError(response);
  }

  const xtremepushData = getState().auth.xtremepushData;

  logXtremePush(
    process.env.REACT_APP_XTREMEPUSH_PREFIX,
    "event",
    activePickem?.stake > 0 ? "placebet" : "placefreebet",
    {
      AppName: process.env.REACT_APP_TITLE,
      ContestName: activePickem?.name,
      ...xtremepushData,
    }
  );

  logXtremePush(
    process.env.REACT_APP_XTREMEPUSH_PREFIX,
    "tag",
    activePickem?.stake > 0 ? "placebet" : "placefreebet",
    {
      AppName: process.env.REACT_APP_TITLE,
      ContestName: activePickem?.name,
      ...xtremepushData,
    }
  );

  const { data } = res?.data;

  const activeBet = {
    betId: data?.id,
    ...data,
    selections,
  };

  setTimeout(() => {
    dispatch(
      setBetbarParent({
        hadBet: true,
        activeBet,
        isPopupVisible: isOver24,
        isPlacingBet: false,
      })
    );

    handlePlaceBetSuccess();
  }, 500);
};
